import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'components/core';

export type FormSubmitButtonProps = {
  children?: React.ReactNode;
  requiredFieldKeys?: string[];
  type?: 'button' | 'reset' | 'submit';
  variant?: string;
};

export const FormSubmitButton = ({
  children,
  requiredFieldKeys,
  type = 'submit',
  ...props
}: FormSubmitButtonProps): JSX.Element => {
  const { errors, formState } = useFormContext();
  const { dirtyFields, isDirty, isSubmitting } = formState;
  const allPopulated = requiredFieldKeys
    ? requiredFieldKeys.every((field) => Object.keys(dirtyFields).includes(field))
    : true;

  const isValid = !isSubmitting && isDirty && allPopulated && Object.keys(errors).length === 0;

  return (
    <Button disabled={!isValid} loading={isSubmitting} type={type} size='large' fluid {...props}>
      {children}
    </Button>
  );
};
